import React, { Component } from 'react';
import ChatPanel from '../components/ChatPanel';
import SummaryPanel from '../components/SummaryPanel';
import '../../constants/styles/currentSession.scss';

class CurrentSession extends Component {
    state = {
        showEndChatButton: false
    };

    handleEndChat = () => {
        this.setState({ showEndChatButton: true });
    };

    render() {
        const { chatDetails, endChat, summaryData, onEndChat } = this.props;
        const { chatStarted, conversationId, initialBotMessage, conversationHistory } = chatDetails;
        return (
            <div className="CurrentSession">
                <div className="ChatHeader">
                    <h1 className="ChatTitle"> </h1>
                </div>
                {!chatDetails.chatEnded ? (
                    <ChatPanel
                        conversationId={conversationId}
                        initialBotMessage={initialBotMessage}
                        endChat={endChat}
                        onEndChatTriggered={this.handleEndChat}
                        showEndChatButton={this.state.showEndChatButton}
                        hashedInput={this.props.hashedInput}
                        userId={this.props.userId}
                    />
                ) : (
                    <SummaryPanel
                        summaryData={summaryData}
                        conversationHistory={conversationHistory}
                        conversationId={conversationId}
                        updateSummaryData={this.props.updateSummaryData}
                        setActivePanel={this.props.setActivePanel}
                    />
                )}
            </div>
        );
    }
}
export default CurrentSession;